import Plausible from 'plausible-tracker'
const { enableAutoPageviews, trackEvent } = Plausible()

class AnalyticsService {
  private plausible = Plausible({
    domain: 'app.leealabs.com'
  })

  constructor() {
    enableAutoPageviews()
  }

  public logTab = (name: string) => {
    trackEvent(`Tab${name}`)
  }

  public logStartFarming = () => {
    trackEvent('FarmingStart')
  }

  public logStopFarming = () => {
    trackEvent('FarmingStop')
  }

  public logGameStart = () => {
    trackEvent('GameStart')
  }
  public logGameCompleted = () => {
    trackEvent('GameCompleted')
  }

  public logGameFailed = () => {
    trackEvent('GameFailed')
  }

  public logNavigateToInvite = () => {
    trackEvent('NavigateToInvite')
  }

  public logInviteClicked = () => {
    trackEvent('InviteOpened')
  }

  public logInviteCopy = () => {
    trackEvent('InviteCopy')
  }

  public logInviteShare = () => {
    trackEvent('InviteShare')
  }
}

export const analyticsService = new AnalyticsService()
